export default {
  ResetPwdSuccess: '重置密码成功!',
  UserName: '用户名',
  CName: '显示名',
  InitPwd: '初始密码',
  ResetPwd: '重设密码',
  EditSuccess: '编辑成功',
  CreateSuccess: '创建成功',
  SubUserManage: '子用户管理',
  YouCanCreateSubUser: '您可以创建一个或多个子用户，授权您的账号关联的网关设备，允许其访问关联网关设备相关配置并使用相关功能。',
  NewUser: '新建用户',
  SearchUser: '搜索用户名/显示名/授权网关/分支机构',
  PleaseEnterName: '请输入用户名',
  AuthGateway: '授权网关',
  SpecialReminder: '特别提醒：取消已授权网关将导致子用户创建的关联网关的访问控制规则、qos策略、流量管控等失效。',
  UserNameTest: '用户名由3到16位的英文或数字组成',
  CNameTest: '显示名由2到15位的中文、英文或数字组成',
  PleaseGateway: '请至少关联一个网关',
  AddChildUser: '新增子用户',
  EditChildUser: '编辑子用户',
  AreYouSureResetPwd: '您确定要重置密码吗?',
  Manageable: '可管理',
  ViewOnly: '仅查看',
}